import { vleiReportingURL, } from '@/constants/api'

import {
  SET_CREDENTIALS_RECORD,
  SET_ERROR,
  SET_HAS_ERROR,
  CHANGE_LOADING,
  RESET_CREDENTIALS_RECORD,
} from './mutations-types'

import { getData, } from '../../helpers'

export default {

  async getCredentials ({ commit, state, }, { lei, page = 1, }) {

    commit(CHANGE_LOADING, true)

    return getData({ state, }, {
      baseUrl: vleiReportingURL,
      endpoint: `le-credentials?filter[lei]=${lei}&page[number]=${page}`,

      cb: (credentials) => {
        commit(RESET_CREDENTIALS_RECORD)
        commit(SET_CREDENTIALS_RECORD, {
          credentials,
          lei,
        })
        commit(CHANGE_LOADING, false)
      },
      cbCatch: (e) => {
        console.error('credentials were not found', e.message)
        commit(SET_ERROR, e.message)
        commit(SET_HAS_ERROR, true)
        commit(CHANGE_LOADING, false)
      },
    })

  },

  getRoleCredentials ({ dispatch, }, { credentialSaid, page = 1, }) {
    return dispatch('getRoles', {
      said: credentialSaid,
      page: page,
    }).then((roles) => roles)
  },

  async getRoles ({ state, }, { said, page = 1, }){
    return getData({ state, }, {
      baseUrl: vleiReportingURL,
      endpoint: `le-credentials/${said}/oor-credentials?page[number]=${page}`,
      cb: (roles) => roles,
    })
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/credential/actions.js